export default __webpack_public_path__ + "static/media/main_all_background.faa81e6f.jpg";